import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IFormatSpecification } from "../IFormatSpecification";
import { ITextPresentableObject } from "../objects";
import { ITextPropertyEditable } from "../properties";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export abstract class AbstractTextPresentableObjectEditor<TObject extends ITextPresentableObject> extends AbstractRectangleCoordinatableObjectEditor<TObject> implements ITextPropertyEditable {
  constructor(source: TObject | AbstractTextPresentableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._text = this.createTextPropertyEditor(s => false); // 既定は編集不可に.必要な派生クラスでoverrideする想定.
  }

  protected createTextPropertyEditor(isWritable?: (s: TObject) => boolean): IPropertyEditable<string> {
    return this.createPropertyEditor(
      s => s.text,
      (s, v) => s.text = v,
      isWritable ? isWritable : s => true);
  }

  protected _text: IPropertyEditable<string>;

  text(): IPropertyEditable<string> {
    return this._text;
  }
}
